import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import CustomCursor from "@/components/CustomCursor";
import Landing from "@/pages/Landing";
import GisPage from "@/pages/GisPage";
import PortfolioPage from "@/pages/PortfolioPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <CustomCursor />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/gis" element={<GisPage />} />
          <Route path="/portfolio" element={<PortfolioPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
